<div class="container transcript-container" [innerHtml]="(transcript$ | async)?.Body">
</div>